module.exports = __webpack_public_path__ + "img/CHAHH@2x.e56674e0.png";